module.exports = __webpack_public_path__ + "static/img/Frame 1851.719dbf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1851.png
// module id = //FC
// module chunks = 12